<template>
  <messenger-qr-code-view-layout
    :channel-title="viewSettings.channel.name"
    :channel-type="viewSettings.channel.type"
    :content-title="viewSettings.title"
    :content-description="viewSettings.description"
    :button-text="viewSettings.buttonText"
    :scan-qr-text="$t('messengerWidget.scanQrToSendMessage')"
    :contact-warning-text="$t('messengerWidget.smsCharges')"
    :contact-data="contactData"
    :show-qr-code="viewSettings.showQrCode"
    @back="$emit('back')"
    @resize="$emit('resize', $event)"
  >
    <template v-slot:alert>
      <slot name="alert"></slot>
    </template>
    <template v-slot:not-exists-contact-data>
      <slot name="not-exists-contact-data"></slot>
    </template>
  </messenger-qr-code-view-layout>
</template>

<script setup lang="ts">
import type { MessengerSmsViewSettings, QrCodeContactData } from '@widgets/messenger/types'
import { phoneService } from '@widgets/shared/services/phoneService'
import MessengerQrCodeViewLayout from '@widgets/messenger/components/MessengerQrCodeViewLayout.vue'
import { computed } from '@/composition/vue/compositionApi'

const props = defineProps<{
  viewSettings: MessengerSmsViewSettings
}>()

defineEmits<{
  (e: 'back'): void
  (e: 'resize', height: number): void
}>()

const contactData = computed(() => {
  const { suitableNumber } = props.viewSettings
  if (!suitableNumber) {
    return undefined
  }
  const href = suitableNumber ? phoneService.getHrefForSms(suitableNumber.phone) : ''
  return {
    phoneNumber: suitableNumber,
    href,
  } satisfies QrCodeContactData
})
</script>
